import { createResource, createEndpoint } from './Schema';
import { UploadModel } from './Schema/Models';
import api from './Schema/Api';

/*
 * static s'applique au model
 * methods s'applique à la resource
 */
const sync = false;
const methods = {};

const UploadResource = createResource(api, UploadModel, {
  static: { sync },
  methods,
});

export const Upload = createEndpoint(UploadResource, '', { static: {} });
